export default () => ({
	shownCount: 0,
	loadingChildren: [],

	isChildLoading() {
		return this.loadingChildren.reduce((a, b) => b || a, false);
	},

	expand() {
		if (!isChildLoading()) {
			this.shownCount++;
		}
	},

	get sizeParams(){
		let base = '';
		const width = this.selectedWidth;
		const height = this.selectedHeight;
		const depth = this.selectedDepth;
		if(width){
			base += `szelesseg=${width}&`
		}

		if(height){
			base += `magassag=${height}&`
		}

		if(depth){
			base += `melyseg=${depth}&`
		}

		return base;
	},

	get selectedWidth(){

		const params = Array.from(new URL(document.location).searchParams.keys())
		const width = params.find((key) => key.includes('width'));
		return width ? width.split('_')[2] : null;
	},

	get selectedHeight(){
		const params = Array.from(new URL(document.location).searchParams.keys())
		const height = params.find((key) => key.includes('height'));
		return height ? height.split('_')[2] : null;
	},

	get selectedDepth(){
		const params = Array.from(new URL(document.location).searchParams.keys())
		const depth = params.find((key) => key.includes('depth'));
		return depth ? depth.split('_')[2] : null;
	}

});
